exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-wrapper{color:#5a5a5a}.help-wrapper .header{height:48px;padding:0 16px;color:#fff;background-color:#0096d6}.help-wrapper .header .hp-icon{height:32px;width:32px;color:#fff;margin-right:16px}.help-wrapper .header .close{height:24px;width:24px;color:#fff;cursor:pointer}.help-wrapper .content .pdf{width:100%;border:none}.help-wrapper .content .video{max-height:100%}.help-wrapper .content .video .videoplayer{height:100%;width:100%}.help-wrapper .footer{border-top:1px solid #ccc;padding:0 16px;height:64px}.help-wrapper .footer .help-feedback{font-size:24px;font-weight:400;color:#5a5a5a}.help-wrapper .footer .feedback-image{height:48px;width:48px;margin:0 16px;cursor:pointer}.help-wrapper .footer .feedback-image.up{color:#509137}.help-wrapper .footer .feedback-image.down{color:#f04b37}.help-wrapper .survey-hidden{max-height:0!important}.help-wrapper .survey-container{overflow:hidden;padding-left:5px;max-height:64px;transition:max-height .5s linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/help/help-wrapper.scss
// module id = 134
// module chunks = 0